import React from "react";
import Field from "@/components/post-ad/Field";
import ConditionTiles from "@/components/post-ad/ConditionTiles";
import { POST } from "@/constants/testIds";

const TIMELINE_OPTIONS = [1, 2, 3, 6, 12];

/**
 * Duration + price row. In edit mode duration is optional (only sent when
 * the user picks a value → extends expiry from now). Also owns the 5-tier
 * condition-tiles control — rendered when the schema declares a
 * `condition` field in its `price` core section (schema-driven site-wide).
 */
export default function TimelinePriceSection({ form, set, isEdit, priceSection, priceHint }) {
  const conditionField = (priceSection?.fields || []).find((f) => f.key === "condition");
  const otherPriceField = (priceSection?.fields || []).find((f) => f.key === "other_price");
  return (
    <>
      <Field label={isEdit ? "Extend listing (optional)" : "Listing duration"}>
        <div className="flex flex-wrap gap-2 items-center">
          {TIMELINE_OPTIONS.map((m) => (
            <button
              key={m}
              type="button"
              onClick={() => set({ duration_months: form.duration_months === m ? null : m })}
              data-testid={`post-ad-duration-${m}`}
              className={`rounded-full px-4 py-1.5 text-xs font-bold border transition-colors ${
                form.duration_months === m
                  ? "bg-[color:var(--brand-blue)] text-white border-transparent"
                  : "bg-white text-slate-700 border-soft hover:border-[color:var(--brand-blue)]"
              }`}
            >
              {m} month{m > 1 ? "s" : ""}
            </button>
          ))}
          {isEdit && (
            <span className="text-[11px] text-slate-500 ml-2">
              Pick a duration only if you want to extend expiry from now.
            </span>
          )}
        </div>
      </Field>

      <Field label="Price ($)">
        <input
          data-testid={POST.price}
          value={form.price}
          onChange={(e) => set({ price: e.target.value.replace(/[^0-9.]/g, "") })}
          className="input"
          placeholder="e.g. 12500 (leave blank for POA)"
        />
        {/* Iter-352 — market-range hint from the car valuation deep-link.
            Guidance only: it never touches the price field. */}
        {priceHint && (
          <p className="mt-1.5 text-xs font-semibold text-emerald-700" data-testid="post-ad-price-hint">
            {priceHint}
          </p>
        )}
      </Field>

      {otherPriceField && (
        <Field label="Other Price ($)">
          <input
            data-testid="post-ad-other-price"
            value={form.other_price || ""}
            onChange={(e) =>
              set({ other_price: e.target.value.replace(/[^0-9.]/g, "") })
            }
            className="input"
            placeholder="Optional secondary price"
          />
        </Field>
      )}

      {conditionField && (
        <ConditionTiles
          value={form.condition}
          onChange={(v) => set({ condition: v })}
          testIdPrefix="post-ad-condition"
        />
      )}
    </>
  );
}
